import type { SelectionAsRecord } from '@/components/Calendar/typings'
import { isSameDay } from 'date-fns/esm'

interface Params {
  date: Date
  dateAsString: string
  selectionStart?: Date
  selectionEnd?: Date
  nextDayAsString: string
  selection: SelectionAsRecord
  edgeOfSelection?: SelectionAsRecord
}

/**
 * Compute some date useful
 */
export function getSelectionData(params: Params) {
  const { date, selection, edgeOfSelection, selectionEnd, selectionStart, dateAsString } = params

  const selected = selection.hasOwnProperty(dateAsString)
  const isSelectionStart = !!selectionStart && isSameDay(selectionStart, date)
  const isSelectionEnd = !!selectionEnd && isSameDay(selectionEnd, date)
  const isOnTheEdge = !!edgeOfSelection && edgeOfSelection.hasOwnProperty(dateAsString)

  return { selected, isOnTheEdge, isSelectionStart, isSelectionEnd }
}
